// extracted by mini-css-extract-plugin
export default {"body":"Admin_body__m5u+B","h1":"Admin_h1__xdVBY"};